import Vue from 'vue';

import { mapMutations, mapState } from 'vuex';

import Button from '@components/ui/button.vue';

let PageComponent = {
  name: 'contacts',
  data() {
    return {
      template: '<p>default temp</p>',
    };
  },
  components: {
    't-button': Button,
  },
  computed: {
    ...mapState('params', ['mobile']),
  },
  methods: {
    ...mapMutations('params', ['toggleRightMenu', 'toogleFeedackOwner']),
    setTemplate: function(template) {
      this.template = template.data;
    },
    setData: function(data, to) {
      this.setTemplate(data);
    },
    initMap: function(value) {
      const coordinates = value.split(' ');
      //    let position = { lat: 55.57147, lng: 37.760771 };
      let position = {
        lat: parseFloat(coordinates[0]),
        lng: parseFloat(coordinates[1]),
      };

      setTimeout(() => {
        let map = new google.maps.Map(this.$refs['contact-map'], {
          zoom: 20,
          center: position,
          disableDefaultUI: true,
        });
        let marker = new google.maps.Marker({
          position: position,
          map: map,
        });
      }, 100);
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeRouteEnter(to, from, next) {
    let contacts = document.querySelector('#contacts');
    if (contacts) {
      contacts.remove();
    }

    let url = '/api/templates/info/contacts';
    Vue.http.get(url, { params: to.query }).then((data) => {
      next((vm) => vm.setData(data));
    });
  },
  mounted() {
    if (!this.mobile) {
      setTimeout(() => {
        wavify(document.querySelector('#map-top-wave'), {
          height: 80,
          bones: 5,
          amplitude: 45,
          color: '#FFFFFF',
          speed: 0.13,
        });
      }, 90);
      setTimeout(() => {
        wavify(document.querySelector('#map-bottom-wave'), {
          height: 15,
          bones: 4,
          amplitude: 70,
          color: '#FFFFFF',
          speed: 0.12,
        });
      }, 150);
    }
  },
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement);
  },
};
export default PageComponent;



// WEBPACK FOOTER //
// ./src/templates/pages/info/contacts/index.js